import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
    admins: {},
    clients: {},
    roles: {},
    missions: {},
    list: [],
};

// ==============================|| SLICE - PAGES ||============================== //

const pages = createSlice({
    name: 'pages',
    initialState,
    reducers: {
        save(state, action) {
            state[action.payload[0]] = {
                ...state[action.payload[0]],
                [action.payload[1]]: action.payload[2],
            };
        },

        set(state, action) {
            state[action.payload[0]] = {
                ...state[action.payload[0]],
                [action.payload[1]]: action.payload[2],
            };
        },
        clear(state, action) {
            state[action.payload[0]] = {};
        },
        remove(state, action) {
            const { name: slice, data } = action.payload;
            state[slice] = state[slice].filter(
                item => !data.includes(item.uuid),
            );
            state.index = data.reduce((index, uuid) => {
                if (uuid in index) {
                    // eslint-disable-next-line no-unused-vars
                    const { [uuid]: _, ...restIndex } = index;
                    return restIndex;
                }
                return index;
            }, {});
        },
    },
});

export default pages.reducer;

export const { set, remove, save, clear } = pages.actions;
